import React, { useState } from "react";
import styled from "styled-components";
import { theme } from "../theme";

const SwitchContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border: 1px solid ${theme.nightMode.color3};
  height: 29px;
  border-radius: 31px;
  cursor: pointer;
  margin: 0 22px 30px;
  @media (min-width: 1800px) {
    height: 48px;
    border: 2px solid ${theme.nightMode.color3};
    margin: 0 45px 30px;
  }
`;

const SwitchOption = styled.span`
  margin: -1px;
  font-size: 15px;
  text-align: right;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  border-radius: 31px;
  background-color: ${props =>
    props.chosen ? props.theme.buttonSecondary : "transparent"};
  @media (min-width: 1800px) {
    font-size: 19px;
    line-height: 32px;
  }
  color: ${props =>
    props.chosen ? props.theme.white : props.theme.disabledText};
`;

const SwitchTweet = () => {
  const [selected, setSelected] = useState(1);
  return (
    <SwitchContainer>
      <SwitchOption chosen={selected === 1} onClick={() => setSelected(1)}>
        تغريدات عامة
      </SwitchOption>
      <SwitchOption chosen={selected === 2} onClick={() => setSelected(2)}>
        تغريدات الجهة
      </SwitchOption>
    </SwitchContainer>
  );
};

export default SwitchTweet;
